import { render, staticRenderFns } from "./GiftCertificateShow.vue?vue&type=template&id=21cfa2f0"
import script from "./GiftCertificateShow.vue?vue&type=script&lang=ts"
export * from "./GiftCertificateShow.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports